import { Component, createRef, createElement } from 'react';
import { Form as OriginalForm, ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import enUS from 'antd/es/locale/en_US';
import 'antd/dist/antd.variable.min.css';
import '../../variables.scss';
import { withSingleFunctionChild } from '../../utils/hoc';
class Form extends Component {
    formRef = createRef();
    componentDidUpdate(prevProps) {
        const { values: prevValues } = prevProps;
        const { values: currentValues } = this.props;
        if (prevValues !== currentValues) {
            if (currentValues && Object.keys(currentValues).length > 0) {
                this.formRef.current.setFieldsValue(currentValues);
            }
            else {
                this.formRef.current.resetFields();
            }
        }
    }
    componentDidMount() {
        const { values } = this.props;
        Object.defineProperties(this, Object.keys(this.formRef.current).reduce((out, key) => {
            const property = this.formRef.current[key];
            let getter = () => property;
            if (typeof property === 'function') {
                getter = () => property.bind(this.formRef.current);
            }
            out[key] = { get: getter };
            return out;
        }, {}));
        // 绑定表达式的时候，初次不生效，需要第一次调用一下 setFieldsValue
        if (values) {
            this.formRef.current.setFieldsValue(values);
        }
    }
    render() {
        ConfigProvider.config({
            theme: {
                primaryColor: '#f16622',
            },
        });
        const { values, ...rest } = this.props;
        return (createElement(ConfigProvider, { locale: localStorage.getItem('umi_locale') !== 'en-US' ? zhCN : enUS },
            createElement(OriginalForm, { ref: this.formRef, ...rest })));
    }
}
Form.Item = (props) => {
    const { name, requiredobj, typeobj, patternobj, lenobj, validator } = props;
    const rules = [];
    if (requiredobj && requiredobj.required) {
        rules.push(requiredobj);
    }
    if (typeobj && typeobj.type) {
        rules.push(typeobj);
    }
    if (patternobj && patternobj.pattern) {
        rules.push(patternobj);
    }
    if (lenobj && (lenobj.max || lenobj.min)) {
        rules.push(lenobj);
    }
    if (validator && typeof validator === 'function') {
        rules.push({
            validator: (_, value) => validator(value),
        });
    }
    const namePath = typeof name === 'string' && name.indexOf('.') > 0 ? name.split('.') : name;
    // https://ant.design/components/form-cn/#components-form-demo-complex-form-control
    // <Form.Item name="field" /> 只会对它的直接子元素绑定表单功能
    const { children, ...other } = props;
    let node = children;
    if (Array.isArray(children) && children.length === 1) {
        // 如果 children.length > 1， 说明 Form.Item 只充当布局的作用
        node = children[0];
    }
    return (createElement(ConfigProvider, { locale: localStorage.getItem('umi_locale') !== 'en-US' ? zhCN : enUS },
        createElement(OriginalForm.Item, { ...other, name: namePath, rules: rules }, node)));
};
Form.List = withSingleFunctionChild(OriginalForm.List);
export default Form;
